import { apiClient } from './authService';

const normalizeResults = (data) => {
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data)) return data;
  return [];
};

const formationService = {
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = queryParams ? `/formations/?${queryParams}` : '/formations/';
    const response = await apiClient.get(url);
    return response.data;
  },

  getSessionOptions: async () => {
    const response = await apiClient.get('/formations/session-options/');
    return normalizeResults(response.data);
  },

  getById: async (id) => {
    const response = await apiClient.get(`/formations/${id}/`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/formations/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/formations/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/formations/${id}/`);
    return response.data;
  },

  hardDelete: async (id) => {
    const response = await apiClient.delete(`/formations/${id}/hard_delete/`);
    return response.data;
  },
};

export default formationService;
